// Copyright aptihealth, inc. 2019 All Rights Reserved
import React, { Component } from "react";
import { Form } from "formik";
import { EMERGENCY_SCHEMA } from "../../../containers/Dashboard/Patient/schema/PatientProfileInfoSchema";
import FormikInput from "../../UI/FormikInput";
import { renderTitleWithValue } from "./Profile";
import SubmitControls from "./SubmitControls";
import Hr from "../../UI/Hr";
import FormikInputFormat from "../../UI/formikMobileInput";
import * as yup from "yup";
import { RE_PHONE } from "../../../constants/regex";
import { CustomForm } from "../../../component-library/CustomForm";
import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";

/** Only mobile number format needs to be validated, no required fields */
const VALIDATION_SCHEMA = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .matches(RE_PHONE, "Emergency Contact Number must be a valid US number"),
});

class EmergencyInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileData: props.data,
      edit: props.edit,
    };
  }

  toggleEditEmergencyInfo = () => {
    this.setState((ps) => {
      return {
        edit: !ps.edit,
      };
    });
  };

  submitHandler = (formData, action) => {
    let data = { ...formData };

    this.setState((ps) => {
      return {
        profileData: { ...data },
        edit: !ps.edit,
      };
    });
    this.props.submit(data, action, EMERGENCY_SCHEMA);
  };

  renderEmergencyForm = (formikProps) => {
    return (
      <Form style={{ width: "100%" }}>
        <div className="mx-auto px-0">
          <div className="container px-0">
            <div className="row">
              {EMERGENCY_SCHEMA.map((formEl) => {
                return (
                  <div key={formEl.name} className="col-12 col-lg-6">
                    {formEl.name === "emergency_contact_number" ? (
                      <FormikInputFormat
                        value={formikProps && formikProps.values.emergency_contact_number}
                        onChange={async (val) => {
                          await formikProps.setFieldValue("emergency_contact_number", val.value);
                          formikProps.setFieldTouched("emergency_contact_number");
                        }}
                        formEl={formEl}
                        errors={formikProps.errors}
                        touched={formikProps.touched}
                      />
                    ) : (
                      <FormikInput
                        formEl={formEl}
                        errors={formikProps.errors}
                        touched={formikProps.touched}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="mb-3 d-lg-none">
          <Hr />
        </div>
        <SubmitControls cancelHandler={this.toggleEditEmergencyInfo} />
      </Form>
    );
  };

  render = () => (
    <DashboardCard2
      title="Emergency Contact Information"
      Actions={
        <Button2
          onPress={this.toggleEditEmergencyInfo}
          className={cn("tw:border-transparent", this.state.edit && "tw:hidden")}
          variant="text"
          size="sm"
        >
          Edit
        </Button2>
      }
    >
      <div className="PatientProfile__basic-info row no-gutters">
        {!this.state.edit &&
          iterableEmergencyInfo(this.state.profileData).map((item) => {
            return (
              <div key={item.title} className="col-12 col-lg-6">
                {renderTitleWithValue(item.title, item.value)}
              </div>
            );
          })}

        {this.state.edit && (
          <CustomForm
            initialValues={this.state.profileData}
            validationSchema={VALIDATION_SCHEMA}
            onSubmit={this.submitHandler}
            render={this.renderEmergencyForm}
          />
        )}
      </div>
    </DashboardCard2>
  );
}

export default EmergencyInfo;

export const iterableEmergencyInfo = (profileData) => [
  { title: "Emergency Contact Person", value: profileData.emergency_contact_person || "" },
  { title: "Emergency Contact Number", value: profileData.emergency_contact_number || "" },
];
